import get from 'lodash.get';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../button/Button';
import {
    APPLICATIONS_GROUPS_NAMES,
    APP_GROUP_BY_APPLICATION_ID,
    APP_GROUPS_DISPLAY_NAMES,
    AVAILABLE_APP_GROUPS,
    MATH,
} from '../../constants/applications';
import { navigateToMathClassList } from '../../common/navigation/navigation';
import { useAppConfigContext } from '../../common/contexts/AppConfigContext';
import { appGroupType } from '../../constants/prop-types';

const onAppGroupClick = (groupName, selectedClassId, selectAppGroup, isSelectable) => () => {
    if (isSelectable) {
        selectAppGroup(groupName);
    } else if (groupName === MATH) {
        navigateToMathClassList(selectedClassId);
    }
};

const groupClasses = (name, selectedAppGroup) =>
    classNames('dashboard-app-group-button', {
        'dashboard-selected': name === selectedAppGroup,
    });

const getAppGroupButton = (
    groupName,
    selectedClassId,
    selectAppGroup,
    selectedAppGroup,
    isSelectable,
) => (
    <Button
        cssClasses={groupClasses(groupName, selectedAppGroup)}
        key={groupName}
        onClick={onAppGroupClick(groupName, selectedClassId, selectAppGroup, isSelectable)}
    >
        {APP_GROUPS_DISPLAY_NAMES[groupName]}
    </Button>
);

const isSelectableAppGroup = name => AVAILABLE_APP_GROUPS.includes(name);

const AppGroups = ({ selectedClassId, selectAppGroup, selectedAppGroup }) => {
    const { appConfigs } = useAppConfigContext();
    const applications = Object.keys(appConfigs);
    const availableAppGroups = applications
        .map(appName => get(APP_GROUP_BY_APPLICATION_ID, appName))
        .filter(groupName => groupName);
    return (
        <div className='dashboard-app-groups'>
            {APPLICATIONS_GROUPS_NAMES.map(
                name =>
                    availableAppGroups.includes(name) &&
                    getAppGroupButton(
                        name,
                        selectedClassId,
                        selectAppGroup,
                        selectedAppGroup,
                        isSelectableAppGroup(name),
                    ),
            )}
        </div>
    );
};

AppGroups.propTypes = {
    selectAppGroup: PropTypes.func.isRequired,
    selectedAppGroup: appGroupType.isRequired,
    selectedClassId: PropTypes.string.isRequired,
};

export default AppGroups;
